import React, { useState } from 'react';
import styled from 'styled-components';
import Icon from './forms/Icon';
import Card from './forms/Card';
import { shortHandDate } from './utility/functions';

const Wrapper = styled.div`
    position: relative;
`
const ButtonIcon = styled(Icon)`
    cursor: pointer;
    opacity: 0.5;
    transition: all 0.3s;
    &:hover {
        opacity: 1;
    }
`
const CardWrapper = styled(Card)`
    opacity: ${({ show }) => show ? 1 : 0};
    transition: all 0.2s;
    position: fixed;
    // top: ${({ show }) => show.clientY};
    // left: ${({ show }) => show.clientX};
    z-index: 1;
    padding: 0.4em;
    pointer-events: none;
    max-width: 30svw;
    text-wrap: wrap;
`

const NoteToolTip = ({ ...props }) => {
    const [state, setState] = useState(false);

    return (
        <Wrapper>
            <ButtonIcon
                onMouseOver={(e) => setState(e)}
                onMouseLeave={(e) => setState(false)}
                {...props}
            />

            {props.note && (
                <CardWrapper show={state}>
                    <b>{shortHandDate(props.note.validFrom)}</b>
                    <span>{props.note.noteText}</span>
                </CardWrapper>
            )}
        </Wrapper>
    )
}

export default NoteToolTip;
